const FORMAT_SIZES = {
    WEB: 'WEB',
    TABLET: 'TABLET',
    MOBILE: 'MOBILE',
}

export default FORMAT_SIZES;